import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import * as yup from "yup";

import { Container, Content, Title, Field, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

const EditSegment = props => {
  const [newSegmentName, setNewSegmentName] = useState("");
  const [newSegmentDescription, setNewSegmentDescription] = useState("");
  const [segment, setSegment] = useState("");

  console.log("SEGMENT::", newSegmentName, newSegmentDescription);

  const description = useRef("");
  const id = props.match.params.id;

  useEffect(() => {
    loadAuth();
    loadFaqSegment();
  }, []);

  const loadAuth = async () => {
    if (!isAuthAdmin("banner\\/faq")) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadFaqSegment = async () => {
    await api
      .get(`/faq-categoria/${id}`)
      .then(async res => {
        setSegment(res.data.segmento);
      })
      .catch(err => {
        swal(
          "Não foi possível carregar as categorias de tipo",
          "Favor contactar TI",
          "error"
        );
      });
  };

  const handleSegmentUpdate = async () => {
    const payload = {
      segmento: newSegmentName,
      text_segmento: newSegmentDescription,
    };

    const segmentFaqValidation = await yup.object().shape({
      segmento: yup
        .string("Necessário que informe nome do novo segmento")
        .required("Necessário que informe nome do novo segmento"),
      text_segmento: yup
        .string("Necessário que informe uma descrição para o segmento")
        .required("Necessário que informe uma descrição para o segmento"),
    });

    try {
      await segmentFaqValidation.validate(payload, { abortEarly: true });
      api.put(`/faq-categorias/${id}`, payload).then(async _ => {
        let logs = {
          local: `admin/faq/edit-segment/${id}`,
          texto: `Editou o segmento de FAQ de ${segment} para ${newSegmentName}.`,
        };
        await api.post("system_logs", { acao: JSON.stringify(logs) });
        swal(
          `Segmento ${segment} atualizado para ${newSegmentName} com sucesso`,
          "",
          "success"
        ).then(_ => props.history.push("/admin/faq"));
      });
    } catch (err) {
      swal(
        "Não foi possível atualizar a faq",
        "Favor contactar TI",
        "error"
      ).then(_ => props.history.push("/admin/faq"));
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Editar Segmento: {segment}</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Nome do segmento"
                placeholder="Segmento"
                value={newSegmentName}
                onChange={e => setNewSegmentName(e.target.value)}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Descrição do segmento"
                placeholder="Descrição"
                value={newSegmentDescription}
                onChange={e => setNewSegmentDescription(e.target.value)}
              />
            </Form.Group>

            <Divider hidden />
            <Form.Group>
              <Form.Field
                control={Button}
                onClick={() => handleSegmentUpdate()}
              >
                Enviar
              </Form.Field>
              <Link to="/admin/faq">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(EditSegment);
